// constants
import { showSuccessAlert } from "../../constants/alerts";
import { PayoutActionTypes } from "./constants";

const INIT_STATE = {
  payout: [],
  influencer: null,
  amountDetails: null,
  loading: false,
  initialLoading: false,
  error: null,
};

const Payout = (state: any = INIT_STATE, action: any): any => {
  switch (action.type) {
    case PayoutActionTypes.API_RESPONSE_SUCCESS:
      if (action.payload.actionType === PayoutActionTypes.GET_PAYOUT_BY_INFLUENCER) {
        return {
          ...state,
          loading: false,
          initialLoading: false,
          payout: action.payload.data.payoutDetails,
          amountDetails: action.payload.data.payDetails,
          influencer: action.payload.data.influencer,
        };
      } else if (action.payload.actionType === PayoutActionTypes.GET_PAYOUT_DETAILS) {
        return {
          ...state,
          loading: false,
          initialLoading: false,
          payout: action.payload.data.payoutDetails,
          amountDetails: action.payload.data.totalCommisions,
        };
      }
      return { ...state };

    case PayoutActionTypes.API_RESPONSE_ERROR:
      if (action.payload.actionType === PayoutActionTypes.GET_PAYOUT_BY_INFLUENCER) {
        return {
          ...state,
          error: action.payload.error,
          loading: false,
          initialLoading: false,
        };
      }
      return { ...state };

    case PayoutActionTypes.GET_PAYOUT_BY_INFLUENCER:
      return { ...state, loading: true, initialLoading: true };
    case PayoutActionTypes.GET_PAYOUT_DETAILS:
      return { ...state, loading: true, initialLoading: true };

    default:
      return { ...state };
  }
};

export default Payout;
